import { ThemeDictionary } from "client/Api/Branding/branding";
import { Anchor } from "client/Components";
import { ReactElement } from "react";
import styles from "./PoweredBy.module.less";
import classNames from "classnames";

export type PoweredByTextColor = "default" | "tertiary";
export type PoweredByLogoMaxHeight = "default" | "reduced";

export type PoweredByProps = {
	isPoweredByTextEnabled: boolean;
	logoUrls: ThemeDictionary<string>;
	textColor?: PoweredByTextColor;
	logoMaxHeight?: PoweredByLogoMaxHeight;
};

export const PoweredBy = (props: PoweredByProps): ReactElement => {
	const {
		isPoweredByTextEnabled,
		logoUrls,
		textColor = "default",
		logoMaxHeight = "default"
	} = props;

	return (
		<div className={styles.root} >
			<img
				src={logoUrls.light}
				className={classNames(
					styles.logo,
					styles.logo_light,
					{ [styles.logo_reducedMaxHeight]: logoMaxHeight === "reduced" }
				)}
			/>

			<img
				src={logoUrls.dark}
				className={classNames(
					styles.logo,
					styles.logo_dark,
					{ [styles.logo_reducedMaxHeight]: logoMaxHeight === "reduced" }
				)}
			/>

			{isPoweredByTextEnabled && (
				<>
					<Anchor
						href="http://www.workspace365.net/"
						target="_blank"
						className={classNames(
							styles.link,
							{ [styles.link_tertiary]: textColor === "tertiary"}
						)}
					>
						Powered by Workspace 365
					</Anchor>

					<span
						className={classNames(
							styles.tm,
							{ [styles.tm_tertiary]: textColor === "tertiary" }
						)}
					>
						TM
					</span>
				</>
			)}
		</div>
	);
};
PoweredBy.displayName = "PoweredBy";
